import mwcMarketsCore from 'mwc-markets-core';
import Barometer from './src/barometer.vue';

const { createCustomElement } = mwcMarketsCore;

createCustomElement(Barometer);

export default Barometer;
